var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTransferAccount = function SvgTransferAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.77 9.456 2.927 2.104h-1.86v2.54H6v1.7H1.637a1.5 1.5 0 0 1-1.5-1.5V9.78a.4.4 0 0 1 .634-.324ZM15.366 6.344 12.44 4.24h1.86V1.7h-4.163V0H14.5A1.5 1.5 0 0 1 16 1.5v4.52a.4.4 0 0 1-.634.324Z"
  })), /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    strokeWidth: 1.7,
    cx: 12,
    cy: 11.5,
    r: 3.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0a4.5 4.5 0 0 1 4.49 4.192 5.957 5.957 0 0 0-1.727.756 2.8 2.8 0 1 0-2.076 2.268 5.9 5.9 0 0 0-.604 1.782L4.5 9a4.5 4.5 0 0 1 0-9Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))));
};
export default SvgTransferAccount;